// extracted by mini-css-extract-plugin
module.exports = {"offer-container":"styles-module__offer-container___3CfcD","logo":"styles-module__logo___1Bw7p"};